import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { connect, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { SaveAndBackWithOutTempButtons } from 'components/base/BottomStepComponent';
import { validate } from './CreateEarningRuleValidate';

import { createAction } from 'utils';
import { CREATION_STEP_THREE_CONFIG } from './EarningRuleCreationConfig';
import BaseCreationStepContentByConfig from 'components/base/BaseCreationStepContentByConfig';

const mapPropsToState = (state) => ({
  earningRule: state.createEarningRules.earningRule,
  languages: state.language.allList,
});

function CreateEarningRuleStepThreeV2({ earningRule, languages }) {
  const {
    getValues,
    setValue,
    clearErrors,
    setError,
  } = useFormContext();

  useEffect(() => {
    const executionPriority = getValues("executionPriority");
    if (!executionPriority) {
      setValue("executionPriority", 1, { shouldDirty: true });
    };
  }, []);

  const {
    extraValidate,
  } = CREATION_STEP_THREE_CONFIG

  const history = useHistory();
  const dispatch = useDispatch();

  const stepChangeAction = (isBack) => {
    let isValid = validate({
      getValues: getValues,
      setError,
      clearErrors,
      step: 2,
      isBack,
    });
    if (extraValidate) {
      isValid = isValid && extraValidate({
        getValues,
        setError,
        clearErrors
      })
    }
    if (isBack) {
      dispatch({
        type: 'createEarningRules/stepChange',
        payload: { isBack: isBack, step: 2, isValid },
      });
    } else if (isValid) {
      dispatch(
        createAction('createEarningRules/createOrUpdateEarningRule')({
          isValid: isValid,
          data: getValues(),
          afterAction: earningRule.id
            ? () => history.push({ pathname: '/earns' })
            : null,
        }),
      );
    }
  };


  return (
    <>
      <BaseCreationStepContentByConfig
        configuration={CREATION_STEP_THREE_CONFIG}
        hidePreview={true}
      />
      <SaveAndBackWithOutTempButtons
        saveText={'Save'}
        saveAction={() => {
          stepChangeAction(false);
        }}
        backAction={() => {
          stepChangeAction(true);
        }}
      />
    </>
  );
}


export default connect(mapPropsToState)(CreateEarningRuleStepThreeV2);
